import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlaskit/primitives/compiled';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	popularity: number | undefined;
};

function Popularity(props: Props): React.JSX.Element {
	const { popularity } = props;
	const { formatMessage } = useIntl();

	const content = formatMessage(messages.popularity, { popularity });

	return isVisualRefreshEnabled() ? (
		<Text color="color.text.subtle">{content}</Text>
	) : (
		<Container>{content}</Container>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Container = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
});

export default Popularity;
